import { FC } from 'react'

import AWSLogo from '@/assets/logos/aws.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { Logging } from '@/out/logging'
import { LoggingProps } from '@/pages/settings/logging'
import CloudwatchDetails from '@/pages/settings/logging/cloudwatch/details'
import CloudwatchForm from '@/pages/settings/logging/cloudwatch/form'

type Props = LoggingProps<'cloudwatch'> & {
  configuration: Logging['cloudwatch']
}

const Cloudwatch: FC<Props> = ({ configuration, onSetup, setupTimer, onTest, testTimer, onRemove, removeTimer }) => {
  return (
    <ServiceIntegrationCard
      title="CloudWatch"
      description="Receive logs in AWS CloudWatch log streams"
      icon={<AWSLogo className="w-8 h-8" />}
      iconColor="text-[#252F3E] dark:text-white"
      isConnected={!!configuration}
      setupContent={
        <CloudwatchForm
          setupTimer={setupTimer}
          testTimer={testTimer}
          onSetup={config => onSetup('cloudwatch', config)}
          onTest={config => onTest('cloudwatch', config)}
        />
      }
      manageContent={
        configuration && (
          <CloudwatchDetails
            configuration={configuration}
            timer={removeTimer}
            onRemove={() => onRemove('cloudwatch')}
          />
        )
      }
    />
  )
}

export default Cloudwatch
